// import { FileData } from '@/hooks/useHelpfindUploady';

export function isFileProtected(file: File): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function (event) {
      const content = event.target?.result;
      if (typeof content === 'string' || content instanceof ArrayBuffer) {
        const pdfContent = new Uint8Array(content as ArrayBuffer);
        const pdfText = new TextDecoder().decode(pdfContent);

        // Look for the /Encrypt marker which indicates password protection
        resolve(pdfText.includes('/Encrypt'));
      } else {
        reject(new Error('Unable to read PDF file'));
      }
    };

    reader.onerror = function () {
      reject(new Error('Error reading PDF file'));
    };

    reader.readAsArrayBuffer(file);
  });
}
